export default [
  {
    path: '/dashboard/godigital',
    name: 'dashboard-godigital',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
  },
]
